import React from 'react';
import clsx from 'clsx';

import Skeleton from '@smart-tv/components/skeleton/skeleton';
import { ContentLayout, UIElement } from '@smart-tv/typings/content';
import { getLayout } from '@smart-tv/utils/kmm/helpers';

import styles from './collections.module.scss';
import skeletonStyles from './collections-skeleton.module.scss';

interface Props {
  uiElement: UIElement;
  isProvider?: boolean;
}

const PORTRAIT_ITEM_COUNT = 28;
const LANDSCAPE_ITEM_COUNT = 20;

export const CollectionsSkeleton: React.FC<Props> = (props: Props) => {
  const { uiElement } = props;

  const isLayoutPortrait = getLayout(uiElement.style) === ContentLayout.Portrait;
  const elements = [...Array(isLayoutPortrait ? PORTRAIT_ITEM_COUNT : LANDSCAPE_ITEM_COUNT)];

  return (
    <div
      className={clsx(
        styles['collections__content'],
        isLayoutPortrait
          ? styles['collections__content--portrait']
          : styles['collections__content--landscape']
      )}
    >
      {elements.map((_, index) => (
        <div key={index} className={skeletonStyles['item']}>
          <div
            className={clsx(
              skeletonStyles['image'],
              isLayoutPortrait
                ? skeletonStyles['image--portrait']
                : skeletonStyles['image--landscape']
            )}
          >
            <div className={skeletonStyles['image__fill']}>
              <Skeleton
                variant="rect"
                animation="wave"
                className={skeletonStyles['image__block']}
              />
            </div>
          </div>
          <Skeleton
            variant="rect"
            animation="wave"
            className={skeletonStyles['asset__title__line']}
          />
        </div>
      ))}
    </div>
  );
};

export default CollectionsSkeleton;
